import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import userService from '../../../../../services/user.service';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
function ClinicUserAdd({ setActiveTab }) {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const { clinicId } = useParams();
    const [roles, setRoles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        getRoles();
    }, []);

    const getRoles = () => {
        userService
            .getRoles()
            .then((res) => setRoles(res.data))
            .catch(() => {
                toast.error('Failed to load roles', { position: toast.POSITION.BOTTOM_RIGHT });
            });
    };

    const handleBack = () => {
        setActiveTab?.('clinic-users-tab');
    };

    const onSubmit = (data, e) => {
        setIsSubmitting(true);
        const newData = { ...data, secret: 'ECXuserx1y1z1', clinicId };

        userService
            .addUsers(clinicId, newData)
            .then(() => {
                e.target.reset();
                toast.success('Successfully added new user', { position: toast.POSITION.BOTTOM_RIGHT });
                handleBack();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Error while adding new user', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
                <div>
                    <button type="button" className="clinic-users-back-link mb-2" onClick={handleBack}>
                        <i className="bi bi-arrow-left"></i>
                        Back to Users
                    </button>
                    <h5 className="clinic-users__title mb-1">
                        <i className="bi bi-person-plus text-primary me-1"></i>
                        Add Clinic User
                    </h5>
                    <p className="text-muted small mb-0">Create a new doctor, manager, or staff account.</p>
                </div>
            </div>

            <div className="row g-3">
                <div className="col-lg-8">
                    <div className="notifications-panel">
                        <div className="notifications-panel__header">
                            <i className="bi bi-person-lines-fill"></i>
                            User Details
                        </div>
                        <div className="notifications-panel__body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label htmlFor="firstName" className="notifications-form-label">
                                            First Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            className={`form-control form-control-sm ${errors.firstName ? 'is-invalid' : ''}`}
                                            placeholder="Enter first name"
                                            disabled={isSubmitting}
                                            {...register('firstName', { required: 'First name is required' })}
                                        />
                                        {errors.firstName && <div className="invalid-feedback">{errors.firstName.message}</div>}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="lastName" className="notifications-form-label">
                                            Last Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            className={`form-control form-control-sm ${errors.lastName ? 'is-invalid' : ''}`}
                                            placeholder="Enter last name"
                                            disabled={isSubmitting}
                                            {...register('lastName', { required: 'Last name is required' })}
                                        />
                                        {errors.lastName && <div className="invalid-feedback">{errors.lastName.message}</div>}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="email" className="notifications-form-label">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            className={`form-control form-control-sm ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="Enter email"
                                            disabled={isSubmitting}
                                            {...register('email', {
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: 'Invalid email address',
                                                },
                                            })}
                                        />
                                        {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="role" className="notifications-form-label">
                                            Role <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="role"
                                            className={`form-select form-select-sm ${errors.role ? 'is-invalid' : ''}`}
                                            disabled={isSubmitting}
                                            {...register('role', { required: 'Role is required' })}
                                        >
                                            <option value="">Select a role</option>
                                            {roles.map((item) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.role && <div className="invalid-feedback">{errors.role.message}</div>}
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor="isAuthenticated" className="notifications-form-label">
                                            Authentication Status <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="isAuthenticated"
                                            className={`form-select form-select-sm ${errors.isAuthenticated ? 'is-invalid' : ''}`}
                                            disabled={isSubmitting}
                                            {...register('isAuthenticated', { required: 'Authentication status is required' })}
                                        >
                                            <option value="false">No</option>
                                            <option value="true">Yes</option>
                                        </select>
                                        {errors.isAuthenticated && (
                                            <div className="invalid-feedback">{errors.isAuthenticated.message}</div>
                                        )}
                                        <div className="notifications-form-hint">
                                            If Yes, default password is set to ECXuserx1y1z1.
                                        </div>
                                    </div>
                                </div>

                                <div className="clinic-users-form-actions">
                                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleBack} disabled={isSubmitting}>
                                        Cancel
                                    </button>
                                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => reset()} disabled={isSubmitting}>
                                        <i className="bi bi-arrow-counterclockwise me-1"></i>
                                        Reset
                                    </button>
                                    <button type="submit" className="btn btn-success btn-sm" disabled={isSubmitting}>
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                Adding…
                                            </>
                                        ) : (
                                            <>
                                                <i className="bi bi-floppy me-1"></i>
                                                Save User
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="notifications-panel">
                        <div className="notifications-panel__header">
                            <i className="bi bi-info-circle"></i>
                            Important Note
                        </div>
                        <div className="notifications-panel__body">
                            <div className="notifications-alert-banner">
                                <i className="bi bi-shield-lock"></i>
                                <span>
                                    When authentication is enabled, the default password is <code>ECXuserx1y1z1</code>. Use the password reset
                                    feature after creating the user to send secure reset instructions via email.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ClinicUserAdd;
